import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/App.css';
import { App } from './app';

ReactDOM.render(<App />, document.getElementById('root'));
